module.exports = {
  model: {
    brand: '',
    model: '',
    door_quantity: '',
    power: '',
  },
}
